import { render, staticRenderFns } from "./checkbox-expandable.vue?vue&type=template&id=2493e5b4"
import script from "./checkbox-expandable.vue?vue&type=script&lang=js"
export * from "./checkbox-expandable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports